import { useInfiniteQuery } from '@tanstack/react-query'
import { getUsers } from 'entities/users/api/userApi'
import { User } from 'entities/users/model/usersTypes'
import { useEffect, useMemo } from 'react'

export const useAllUsersQuery = () => {
    const query = useInfiniteQuery({
        queryKey: ['users'],
        queryFn: ({ pageParam = 1 }) => getUsers({ page: pageParam, size: 50 }),
        getNextPageParam: lastPage => {
            const { current_page, total_pages } = lastPage.pagination
            return current_page < total_pages ? current_page + 1 : undefined
        },
        initialPageParam: 1,
    })

    useEffect(() => {
        if (query.data && query.hasNextPage && !query.isFetchingNextPage) {
            query.fetchNextPage()
        }
    }, [query.data, query.hasNextPage, query.isFetchingNextPage])

    const allUsers = useMemo(() => {
        return (query.data?.pages?.flatMap(page => page.users) || []) as User[]
    }, [query.data])

    return {
        allUsers,
        ...query,
    }
}
